import BaseRoute from "utils/base_route";
import DataAssetsCreateView from "./containers/data_assets_create_view";

export default class DataAssetsCreateViewRoute extends BaseRoute {
  constructor(store, path = "create") {
    super(path, store);
  }

  getChildRoutes(state, cb) {
    cb(null, []);
  }
  getComponents(location, cb) {
    cb(null, DataAssetsCreateView);
  }
}
